import { jsx as _jsx } from "react/jsx-runtime";
import BrandHero from '../BrandHero/BrandHero';
const FoodAndBeverageHero = (props) => {
    return _jsx(BrandHero, { ...props });
};
export default FoodAndBeverageHero;
